import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  tr: {
    appName: "LogiHR Global",
    tagline: "Uluslararası Lojistik İnsan Kaynakları",
    login: "Giriş Yap",
    logout: "Çıkış",
    email: "E-posta",
    password: "Şifre",
    rememberMe: "Beni hatırla",
    signInWelcome: "Yönetim paneline hoş geldiniz",
    dashboard: "Panel",
    employees: "Personel",
    documents: "Belgeler",
    contracts: "Sözleşmeler",
    payroll: "Bordro",
    leaves: "İzinler",
    trainings: "Eğitimler",
    performance: "Performans",
    assets: "Zimmet",
    discipline: "Disiplin",
    offboarding: "İşten Ayrılış",
    reports: "Raporlar",
    aiTools: "AI Araçları",
    add: "Ekle",
    edit: "Düzenle",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    search: "Ara...",
    name: "Ad Soyad",
    firstName: "Ad",
    lastName: "Soyad",
    employeeNo: "Sicil No",
    nationalId: "TC Kimlik",
    phone: "Telefon",
    address: "Adres",
    department: "Departman",
    title: "Unvan",
    hireDate: "İşe Giriş Tarihi",
    birthDate: "Doğum Tarihi",
    nationality: "Uyruk",
    iban: "IBAN",
    bankName: "Banka",
    emergencyContact: "Acil Durum Kişisi",
    emergencyPhone: "Acil Telefon",
    employeeType: "Personel Tipi",
    office: "Ofis",
    driver: "Şoför",
    warehouse: "Depo",
    status: "Durum",
    active: "Aktif",
    onleave: "İzinde",
    terminated: "Ayrılmış",
    all: "Tümü",
    totalEmployees: "Toplam Personel",
    activeDrivers: "Aktif Şoför",
    expiringDocs: "Yaklaşan Belgeler",
    pendingLeaves: "Bekleyen İzinler",
    monthlyPayroll: "Aylık Bordro",
    overview: "Genel Bakış",
    recentAlerts: "Son Uyarılar",
    departmentDist: "Departman Dağılımı",
    typeDist: "Personel Tipi",
    personalInfo: "Kişisel Bilgiler",
    logistics: "Lojistik Belgeleri",
    financial: "Finansal",
    uploadDoc: "Belge Yükle",
    docType: "Belge Türü",
    docName: "Belge Adı",
    expiryDate: "Son Kullanma",
    expiresIn: "gün sonra",
    expired: "Süresi dolmuş",
    critical: "Kritik",
    warning: "Uyarı",
    info: "Bilgi",
    newEmployee: "Yeni Personel",
    newContract: "Yeni Sözleşme",
    newLeave: "Yeni İzin",
    newPayroll: "Bordro Oluştur",
    newTraining: "Eğitim Ekle",
    newPerformance: "Değerlendirme Ekle",
    newAsset: "Zimmet Ekle",
    newDiscipline: "Disiplin Kaydı",
    newOffboarding: "Ayrılış Kaydı",
    approve: "Onayla",
    reject: "Reddet",
    paid: "Ödendi",
    markPaid: "Ödeme Yap",
    returnAsset: "İade Al",
    aiContractAnalyzer: "Sözleşme Analizi (AI)",
    aiSummarize: "AI Özetle",
    aiOcr: "AI OCR",
    runAnalysis: "Analizi Çalıştır",
    risks: "Riskler",
    summary: "Özet",
    actionItems: "Yapılacaklar",
    keyTerms: "Önemli Maddeler",
    pasteContract: "Sözleşme metnini buraya yapıştırın...",
    language: "Dil",
    theme: "Tema",
    darkMode: "Koyu",
    lightMode: "Açık",
    role: "Rol",
    admin: "Yönetici",
    hr: "İK",
    manager: "Operasyon Yöneticisi",
    employee: "Personel",
    noData: "Veri bulunamadı",
    complianceRate: "Uyum Oranı",
    turnoverRate: "Devir Oranı",
    docExpiryDist: "Belge Son Kullanma Dağılımı",
    overtimeCost: "Fazla Mesai Maliyeti",
    export: "Dışa Aktar",
    details: "Detaylar",
    back: "Geri",
    period: "Dönem",
    grossSalary: "Brüt Maaş",
    netSalary: "Net Maaş",
    overtime: "Fazla Mesai",
    bonus: "Prim",
    deduction: "Kesinti",
    sgk: "SGK",
    tax: "Vergi",
    workedDays: "Çalışılan Gün",
    leaveType: "İzin Türü",
    annual: "Yıllık",
    sick: "Hastalık",
    unpaid: "Ücretsiz",
    marriage: "Evlilik",
    bereavement: "Vefat",
    startDate: "Başlangıç",
    endDate: "Bitiş",
    days: "Gün",
    reason: "Sebep",
    pending: "Bekliyor",
    approved: "Onaylandı",
    rejected: "Reddedildi",
    category: "Kategori",
    certificateNo: "Sertifika No",
    provider: "Veren Kurum",
    reviewer: "Değerlendiren",
    overallScore: "Genel Puan",
    safetyScore: "Güvenlik",
    deliveryScore: "Teslimat Zamanı",
    fuelScore: "Yakıt Verimliliği",
    comments: "Yorumlar",
    assetName: "Varlık Adı",
    assetType: "Varlık Türü",
    serialPlate: "Seri/Plaka",
    assignedDate: "Verilme Tarihi",
    returnedDate: "İade Tarihi",
    vehicle: "Araç",
    fuelcard: "Yakıt Kartı",
    tablet: "Tablet",
    ppe: "Koruyucu Donanım",
    other: "Diğer",
    incidentDate: "Olay Tarihi",
    actionTaken: "Alınan Önlem",
    lastDay: "Son İş Günü",
    noticeGiven: "İhbar Verildi",
    severance: "Kıdem Tazminatı",
    assetsReturned: "Zimmet İade",
    sgkNotified: "SGK Bildirildi",
    exitInterview: "Çıkış Görüşmesi",
    finalPay: "Son Ödeme",
    checklist: "Kontrol Listesi",
    yes: "Evet",
    no: "Hayır",
    close: "Kapat",
    openProfile: "Profili Aç",
    noUpcoming: "Yaklaşan belge süresi yok. Her şey yolunda.",
    goodMorning: "Günaydın",
    goodAfternoon: "İyi günler",
    goodEvening: "İyi akşamlar",
    quickActions: "Hızlı İşlemler",
    uploadDocLabel: "Dosya Seç",
    download: "İndir",
    salary: "Maaş",
    license: "Ehliyet",
    src: "SRC",
    adr: "ADR",
    psychotechnical: "Psikoteknik",
    tachograph: "Takograf",
    passport: "Pasaport",
    visa: "Vize",
    forklift: "Forklift",
    healthReport: "Sağlık Raporu",
    diploma: "Diploma",
    idDoc: "Kimlik Belgesi",
    contract: "Sözleşme",
    saved: "Kaydedildi",
    error: "Hata",
    success: "Başarılı",
    confirmDelete: "Silmek istediğinize emin misiniz?",
    heroTitle: "Modern. Kurumsal. Lojistik Odaklı.",
    heroDesc: "Uluslararası taşımacılık ekibinizin tüm İK süreçlerini tek bir yerden profesyonelce yönetin.",
    tryDemo: "Demo girişleri",
    currency: "Para Birimi",
  },
  en: {
    appName: "LogiHR Global",
    tagline: "International Logistics HR",
    login: "Sign In",
    logout: "Logout",
    email: "Email",
    password: "Password",
    rememberMe: "Remember me",
    signInWelcome: "Welcome to your management portal",
    dashboard: "Dashboard",
    employees: "Employees",
    documents: "Documents",
    contracts: "Contracts",
    payroll: "Payroll",
    leaves: "Leaves",
    trainings: "Trainings",
    performance: "Performance",
    assets: "Assets",
    discipline: "Discipline",
    offboarding: "Offboarding",
    reports: "Reports",
    aiTools: "AI Tools",
    add: "Add",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    search: "Search...",
    name: "Full Name",
    firstName: "First Name",
    lastName: "Last Name",
    employeeNo: "Employee No",
    nationalId: "National ID",
    phone: "Phone",
    address: "Address",
    department: "Department",
    title: "Title",
    hireDate: "Hire Date",
    birthDate: "Birth Date",
    nationality: "Nationality",
    iban: "IBAN",
    bankName: "Bank",
    emergencyContact: "Emergency Contact",
    emergencyPhone: "Emergency Phone",
    employeeType: "Employee Type",
    office: "Office",
    driver: "Driver",
    warehouse: "Warehouse",
    status: "Status",
    active: "Active",
    onleave: "On Leave",
    terminated: "Terminated",
    all: "All",
    totalEmployees: "Total Employees",
    activeDrivers: "Active Drivers",
    expiringDocs: "Expiring Docs",
    pendingLeaves: "Pending Leaves",
    monthlyPayroll: "Monthly Payroll",
    overview: "Overview",
    recentAlerts: "Alerts",
    departmentDist: "Departments",
    typeDist: "Staff Types",
    personalInfo: "Personal Info",
    logistics: "Logistics Docs",
    financial: "Financial",
    uploadDoc: "Upload Document",
    docType: "Document Type",
    docName: "Document Name",
    expiryDate: "Expiry",
    expiresIn: "days left",
    expired: "Expired",
    critical: "Critical",
    warning: "Warning",
    info: "Info",
    newEmployee: "New Employee",
    newContract: "New Contract",
    newLeave: "New Leave",
    newPayroll: "Create Payroll",
    newTraining: "Add Training",
    newPerformance: "Add Review",
    newAsset: "Add Asset",
    newDiscipline: "Discipline Record",
    newOffboarding: "Offboarding",
    approve: "Approve",
    reject: "Reject",
    paid: "Paid",
    markPaid: "Mark Paid",
    returnAsset: "Return",
    aiContractAnalyzer: "Contract Analyzer (AI)",
    aiSummarize: "AI Summarize",
    aiOcr: "AI OCR",
    runAnalysis: "Run Analysis",
    risks: "Risks",
    summary: "Summary",
    actionItems: "Action Items",
    keyTerms: "Key Terms",
    pasteContract: "Paste the contract text here...",
    language: "Language",
    theme: "Theme",
    darkMode: "Dark",
    lightMode: "Light",
    role: "Role",
    admin: "Admin",
    hr: "HR",
    manager: "Manager",
    employee: "Employee",
    noData: "No data",
    complianceRate: "Compliance Rate",
    turnoverRate: "Turnover Rate",
    docExpiryDist: "Document Expiry Distribution",
    overtimeCost: "Overtime Cost",
    export: "Export",
    details: "Details",
    back: "Back",
    period: "Period",
    grossSalary: "Gross Salary",
    netSalary: "Net Salary",
    overtime: "Overtime",
    bonus: "Bonus",
    deduction: "Deduction",
    sgk: "SGK",
    tax: "Tax",
    workedDays: "Worked Days",
    leaveType: "Leave Type",
    annual: "Annual",
    sick: "Sick",
    unpaid: "Unpaid",
    marriage: "Marriage",
    bereavement: "Bereavement",
    startDate: "Start",
    endDate: "End",
    days: "Days",
    reason: "Reason",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    category: "Category",
    certificateNo: "Certificate No",
    provider: "Provider",
    reviewer: "Reviewer",
    overallScore: "Overall",
    safetyScore: "Safety",
    deliveryScore: "On-Time Delivery",
    fuelScore: "Fuel Efficiency",
    comments: "Comments",
    assetName: "Asset Name",
    assetType: "Asset Type",
    serialPlate: "Serial/Plate",
    assignedDate: "Assigned",
    returnedDate: "Returned",
    vehicle: "Vehicle",
    fuelcard: "Fuel Card",
    tablet: "Tablet",
    ppe: "PPE",
    other: "Other",
    incidentDate: "Incident Date",
    actionTaken: "Action Taken",
    lastDay: "Last Day",
    noticeGiven: "Notice Given",
    severance: "Severance",
    assetsReturned: "Assets Returned",
    sgkNotified: "SGK Notified",
    exitInterview: "Exit Interview",
    finalPay: "Final Pay",
    checklist: "Checklist",
    yes: "Yes",
    no: "No",
    close: "Close",
    openProfile: "Open Profile",
    noUpcoming: "No upcoming expirations. All clear.",
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    quickActions: "Quick Actions",
    uploadDocLabel: "Choose file",
    download: "Download",
    salary: "Salary",
    license: "License",
    src: "SRC",
    adr: "ADR",
    psychotechnical: "Psychotechnical",
    tachograph: "Tachograph",
    passport: "Passport",
    visa: "Visa",
    forklift: "Forklift",
    healthReport: "Health Report",
    diploma: "Diploma",
    idDoc: "ID Document",
    contract: "Contract",
    saved: "Saved",
    error: "Error",
    success: "Success",
    confirmDelete: "Are you sure to delete?",
    heroTitle: "Modern. Corporate. Logistics-first.",
    heroDesc: "Manage your international logistics team's entire HR lifecycle from one professional portal.",
    tryDemo: "Demo logins",
    currency: "Currency",
  },
};

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("logihr_lang") || "tr");
  useEffect(() => localStorage.setItem("logihr_lang", lang), [lang]);
  const t = (k) => translations[lang][k] || translations.en[k] || k;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
